import { render, staticRenderFns } from "./TextAreaItem.vue?vue&type=template&id=f30de536&scoped=true&"
import script from "./TextAreaItem.vue?vue&type=script&lang=ts&"
export * from "./TextAreaItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30de536",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VLabel,VTextarea})
